var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07316 13.5536L11.3734 20.4114C11.6415 20.6633 11.7756 20.7892 11.9361 20.8099C11.9785 20.8153 12.0214 20.8153 12.0638 20.8099C12.2243 20.7892 12.3584 20.6633 12.6265 20.4114L19.9267 13.5536C21.9807 11.6241 22.2302 8.44893 20.5027 6.22237L20.1778 5.80371C18.1112 3.14011 13.9631 3.58682 12.511 6.62933C12.3058 7.05911 11.6941 7.05911 11.489 6.62933C10.0368 3.58682 5.88866 3.14011 3.82207 5.80371L3.49725 6.22237C1.76975 8.44893 2.01918 11.6241 4.07316 13.5536Z",
    stroke: "black",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon_heart.bfc1ec59abc49f2f15c9838bc09be37c.svg";
export { ForwardRef as ReactComponent };